var deviceFeaturesInter = (function () {
  function init() {
    // Sidebar promo badge sticky feature
    var sideBarContainer = document.getElementById('device-features-sidebar-container');
    var promoBadge = document.getElementById('device-features-promo-badge');
    if (promoBadge && sideBarContainer) {
      var badgePositionFromTop =
        (sideBarContainer.offsetHeight - promoBadge.offsetHeight) / 2 + sideBarContainer.offsetTop;
      promoBadge.style.top = badgePositionFromTop + 'px';
      window.addEventListener('scroll', function () {
        var threshold = badgePositionFromTop - window.scrollY;
        if (threshold < 380) {
          promoBadge.classList.add('is-sticky');
          promoBadge.style.top = '380px';
        } else {
          promoBadge.classList.remove('is-sticky');
          promoBadge.style.top = threshold + 'px';
        }
      });
    }

    // Tab Dropdown feature
    document.addEventListener('click', function (event) {
      var ddButton = document.querySelector('.device-features-panel__dropdown'),
        ddTabWrap = document.querySelector('.device-features-panel');
      if (ddTabWrap != null && ddButton != null) {
        if (ddButton == event.target && ddTabWrap.classList.contains('dd-toggle') == false) {
          ddTabWrap.classList.add('dd-toggle');
        } else {
          ddTabWrap.classList.remove('dd-toggle');
        }
      }
    });
  }
  /**
   *** device features Sidebar
   */
  var deviceFeatComponentTabs = document.querySelectorAll('.device-features-panel__list-item[role="tab"]'),
    deviceFeatContentPanel = document.querySelectorAll('.device-features-template__info-section[role="tabpanel"]'),
    activeProductTabName = '';

  if (deviceFeatComponentTabs.length && deviceFeatContentPanel.length) {
    var getURLParam = window.location.hash,
      getActiveTabNameOnLoad = deviceFeatComponentTabs[0].getAttribute('data-tabname');

    if (getURLParam) {
      var getProductTabName = window.location.hash.split('#')[1],
        getActiveTabElem = document.querySelector(
          '.device-features-panel__list-item[data-tabname="' + getProductTabName + '"]'
        ),
        getActiveSectionElem = document.querySelector(
          '.device-features-template__info-section[data-target="' + getProductTabName + '"]'
        );

      if (getActiveTabElem && getActiveSectionElem) {
        if (getProductTabName === getActiveTabElem.getAttribute('data-tabname')) {
          getActiveTabElem.parentElement.classList.add('device-features-panel__list--active');
          getActiveTabElem.setAttribute('aria-selected', 'true');
          getActiveTabElem.removeAttribute('tabindex');
          hideAllDfTabContent(); // hide all DF content
          getActiveSectionElem.setAttribute('aria-hidden', 'false');
          getActiveSectionElem.parentElement.classList.remove('hide');
          getActiveTabNameOnLoad = getProductTabName;

          updateDDButton(getActiveTabElem.getAttribute('title'));
        }
      } else {
        deviceFeatComponentTabs[0].parentElement.classList.add('device-features-panel__list--active');
        deviceFeatComponentTabs[0].setAttribute('aria-selected', 'true');
        deviceFeatComponentTabs[0].removeAttribute('tabindex');
        hideAllDfTabContent(); // hide all DF content
        deviceFeatContentPanel[0].parentElement.classList.remove('hide');
        deviceFeatContentPanel[0].setAttribute('aria-hidden', 'false');

        updateDDButton(deviceFeatComponentTabs[0].getAttribute('title'));
      }
    } else {
      deviceFeatComponentTabs[0].parentElement.classList.add('device-features-panel__list--active');
      deviceFeatComponentTabs[0].setAttribute('aria-selected', 'true');
      deviceFeatComponentTabs[0].removeAttribute('tabindex');
      hideAllDfTabContent(); // hide all DF content
      deviceFeatContentPanel[0].parentElement.classList.remove('hide');
      deviceFeatContentPanel[0].setAttribute('aria-hidden', 'false');
      updateDDButton(deviceFeatComponentTabs[0].getAttribute('title'));
    }

    //active tab name
    activeProductTabName = getActiveTabNameOnLoad;

    // Update Dropdown Text
    function updateDDButton(title) {
      var dropdownTabButton = document.querySelector('.device-features-panel__dropdown');
      if (dropdownTabButton) {
        dropdownTabButton.innerText = title;
      }
    }
    // For easy reference
    var keys = {
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      delete: 46,
      enter: 13,
      space: 32,
    };

    // Add or subtract depending on key pressed
    var direction = {
      37: -1,
      38: -1,
      39: 1,
      40: 1,
    };

    // Bind listeners for product component
    for (var i = 0; i < deviceFeatComponentTabs.length; ++i) {
      setEventsOnDfComponentTabs(i);
    }

    function setEventsOnDfComponentTabs(index) {
      deviceFeatComponentTabs[index].addEventListener('mouseenter', function () {
        lazyLoading.show();
      });

      deviceFeatComponentTabs[index].addEventListener('click', setClickEvtOnDfComponentTab);
      deviceFeatComponentTabs[index].addEventListener('keydown', setKeydownEvtOnDfComponentTab);
      deviceFeatComponentTabs[index].addEventListener('keyup', setKeyupEvtOnDfComponentTab);

      // Build an array with all tabs (<button>s) in it
      deviceFeatComponentTabs[index].index = index;
    }

    // When a tab is clicked, activateTab is fired to activate it
    function setClickEvtOnDfComponentTab(event) {
      var tab = event.target;
      activateDfComponentTab(tab, false);
    }

    // Handle keydown on Product tabs
    function setKeydownEvtOnDfComponentTab(event) {
      var key = event.keyCode;

      switch (key) {
        case keys.end:
          event.preventDefault();
          // Activate last tab
          focusDfComponentLastTab();
          break;
        case keys.home:
          event.preventDefault();
          // Activate first tab
          focusDfComponentFirstTab();
          break;
        default:
      }
    }

    // Handle keyup on Product tabs
    function setKeyupEvtOnDfComponentTab(event) {
      var key = event.keyCode;

      switch (key) {
        case keys.left:
        case keys.right:
          switchDfTabOnArrowPress(event);
          break;
        case keys.enter:
        case keys.space:
          activateDfComponentTab(event.target);
          break;
        default:
      }
    }

    // Either focus the next, previous, first, or last tab
    // depending on key pressed
    function switchDfTabOnArrowPress(event) {
      var pressed = event.keyCode;
      if (direction[pressed]) {
        var target = event.target;
        if (target.index !== undefined) {
          if (deviceFeatComponentTabs[target.index + direction[pressed]]) {
            deviceFeatComponentTabs[target.index + direction[pressed]].focus();
          } else if (pressed === keys.left || pressed === keys.up) {
            focusDfComponentLastTab();
          } else if (pressed === keys.right || pressed == keys.down) {
            focusDfComponentFirstTab();
          }
        }
      }
    }

    // Activates any given tab panel
    function activateDfComponentTab(tab, setFocus) {
      setFocus = setFocus || true;

      // Update dropdown button text
      updateDDButton(tab.getAttribute('title'));

      // Deactivate all other tabs
      deactivateDfComponentTabs();

      // Remove tabindex attribute
      tab.removeAttribute('tabindex');

      // Set the tab as selected
      tab.setAttribute('aria-selected', 'true');

      //set active to parent element
      tab.parentElement.classList.add('device-features-panel__list--active');

      // Get the value of aria-controls (which is an ID)
      var panelControl = tab.getAttribute('aria-controls'),
        panelControlDom = document.getElementById(panelControl); // Remove hidden attribute from product panel to make it visible

      if (panelControlDom) {
        panelControlDom.setAttribute('aria-hidden', 'false');
        panelControlDom.parentElement.classList.remove('hide');
      }

      //show images from lazy load
      lazyLoading.show();

      // Set focus when required
      if (setFocus) {
        tab.focus();
      }

      var tabName = tab.getAttribute('data-tabname');
      activeProductTabName = tabName; //active tab name

      // Set URL for active state
      window.history.pushState({ path: window.location.href }, '', '#' + tabName + '');

      // Fire Amplitude Event on Tab click
      var getDFTabTitle = tab.getAttribute('title').replace(/\s/g, '');
      WebEventTracker.logEvent(EDS.webEvents, 'InteractedWithDeviceFeaturesSummaryPage', {
        product: activeProductTabName,
        action: 'ClickedOn' + getDFTabTitle + 'Tab',
      });

      //scroll to top on tab switch
      var mainDFWrapper = document.getElementById('deviceFeaturesMainWrapper'),
        offsetTop = mainDFWrapper ? mainDFWrapper.offsetTop - 63 : 0;

      offsetTop = window.innerWidth < 980 ? offsetTop + 20 : offsetTop; // for mobile devices add extra buffer

      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth', // Optional: for smooth scrolling
      });
    }

    // Deactivate all tabs and tab panels
    function deactivateDfComponentTabs() {
      for (var j = 0; j < deviceFeatComponentTabs.length; j++) {
        deviceFeatComponentTabs[j].setAttribute('aria-selected', 'false');
        deviceFeatComponentTabs[j].parentElement.classList.remove('device-features-panel__list--active');
      }

      for (var k = 0; k < deviceFeatContentPanel.length; k++) {
        deviceFeatContentPanel[k].setAttribute('aria-hidden', 'true');
        deviceFeatContentPanel[k].parentElement.classList.add('hide');
      }
    }

    // Make a guess
    function focusDfComponentFirstTab() {
      deviceFeatComponentTabs[0].focus();
    }

    // Make a guess
    function focusDfComponentLastTab() {
      deviceFeatComponentTabs[deviceFeatComponentTabs.length - 1].focus();
    }

    // hide all DF content
    function hideAllDfTabContent() {
      for (var k = 0; k < deviceFeatContentPanel.length; k++) {
        deviceFeatContentPanel[k].setAttribute('aria-hidden', 'true');
        deviceFeatContentPanel[k].parentElement.classList.add('hide');
      }
    }
  }

  /**
   *** Amplitude Events binding for Elem Start
   */
  var dFGetStartedBannerCTA = document.querySelector('.df-get-started-banner-cta'),
    dFSideBarCTABtn = document.querySelector('.device-features-template__sidebar-note-cta'),
    dFContentDocumentLink = document.querySelectorAll('.device-features-template__info-table-row-link-box > a');

  if (dFGetStartedBannerCTA) {
    dFGetStartedBannerCTA.addEventListener('click', function () {
      WebEventTracker.logEvent(EDS.webEvents, 'InteractedWithDeviceFeaturesSummaryPage', {
        product: activeProductTabName,
        action: 'ClickedOnMainGetStartedFree',
      });
    });
  }

  if (dFSideBarCTABtn) {
    dFSideBarCTABtn.addEventListener('click', function () {
      WebEventTracker.logEvent(EDS.webEvents, 'InteractedWithDeviceFeaturesSummaryPage', {
        product: activeProductTabName,
        action: 'ClickedOnGetStartedFree',
      });
    });
  }

  if (dFContentDocumentLink.length !== 0) {
    for (var i = 0; i < dFContentDocumentLink.length; i++) {
      dFContentDocumentLink[i].addEventListener('click', setEventsOnDFDocumentationLink);
    }
  }

  function setEventsOnDFDocumentationLink() {
    var getFeatureElem = this.closest('.device-features-template__info-table-row'),
      getFeatureName = getFeatureElem
        ? getFeatureElem.querySelector('.device-features-template__info-table-row-name').innerText
        : '';

    WebEventTracker.logEvent(EDS.webEvents, 'InteractedWithDeviceFeaturesSummaryPage', {
      product: activeProductTabName,
      action: 'ClickedOnDocumentation',
      feature: getFeatureName,
    });
  }
  /**
   *** Amplitude Events binding for Elem End
   */

  /**
   *** DOMContentLoaded Event
   */
  document.addEventListener('DOMContentLoaded', function () {
    deviceFeaturesInter.init();

    // fire Amplitude events on Page Load with Active Tab
    pageLoadEventProps = {
      product : getActiveTabNameOnLoad
    };
  });
  return {
    init: init,
  };
})();
